import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import { isDate } from 'src/app/services/util/utils';

@Pipe({
    name: 'timeDuration',
    standalone: false
})
export class TimeDurationPipe implements PipeTransform {

  transform(startDate: Date, endDate: Date, defaultValue = '', activityLog?: boolean): string {
    if(activityLog) {
      let startDateInternal = startDate;
      if (!isDate(startDate)) {
        startDateInternal = new Date(startDate);
      }
      let endDateInternal = endDate;
      if (!isDate(endDate)) {
        endDateInternal = new Date(endDate);
      }
      const diff = startDateInternal.getTime() - endDateInternal.getTime();
      const formatTime = milliseconds => {
        const seconds = Math.floor((milliseconds / 1000) % 60);
        const minutes = Math.floor((milliseconds / 1000 / 60) % 60);
        const hours = Math.floor(milliseconds / 1000 / 60 / 60);
    
        return [
            hours.toString().padStart(2, "0"),
            minutes.toString().padStart(2, "0"),
            seconds.toString().padStart(2, "0")
        ].join(":");
    }
    
    const formattedTime = formatTime(diff);
    return formattedTime;
    }
    else if (startDate && endDate) {
      let startDateInternal = startDate;
      if (!isDate(startDate)) {
        startDateInternal = new Date(startDate);
      }
      let endDateInternal = endDate;
      if (!isDate(endDate)) {
        endDateInternal = new Date(endDate);
      }
      const diff = endDateInternal.getTime() - startDateInternal.getTime();
      const formatTime = milliseconds => {
        const seconds = Math.floor((milliseconds / 1000) % 60);
        const minutes = Math.floor((milliseconds / 1000 / 60) % 60);
        const hours = Math.floor(milliseconds / 1000 / 60 / 60);
    
        return [
            hours.toString().padStart(2, "0"),
            minutes.toString().padStart(2, "0"),
            seconds.toString().padStart(2, "0")
        ].join(":");
    }
    
    const formattedTime = formatTime(diff);
    return formattedTime;
    }
    return defaultValue;
  }
}